export default "__VITE_ASSET__EaW4kV5K__"